export default "__VITE_ASSET__7bb49980__"